import { companyApi, uploadFileToSignedUrl } from '@l2u/ui/lib/api.ts';
import type { ReplyPayload } from '@l2u/ui/components/ReplyComposer.tsx';

/**
 * Presigns + uploads every attachment to /submissions/:questionId/upload-url,
 * then POSTs the reply to /submissions/:submissionId/comments. Body is omitted
 * when empty; attachments and removes_file_ids omitted when none. Exactly the request QuestionCard
 * sends — shared so the Documents tab's thread modal replies the same way.
 */
export async function postVendorReply(args: {
  apiPrefix: string;
  questionId: string;
  submissionId: string;
  payload: ReplyPayload;
}): Promise<unknown> {
  const { apiPrefix, questionId, submissionId, payload } = args;
  const attachments = [];
  for (const a of payload.attachments) {
    const presigned = await companyApi.post<{ path: string; url: string; token: string }>(
      `${apiPrefix}/submissions/${questionId}/upload-url`,
      { file_name: a.file.name, mime_type: a.file.type || 'application/octet-stream' },
    );
    await uploadFileToSignedUrl(presigned.url, a.file);
    attachments.push({
      attachment_path: presigned.path,
      attachment_name: a.file.name,
      attachment_size_bytes: a.file.size,
      attachment_mime_type: a.file.type || 'application/octet-stream',
      attachment_expires_at: a.expiresAt ?? undefined,
      replaces_file_ids: a.replacesFileIds,
      mode: a.mode,
    });
  }
  return companyApi.post(`${apiPrefix}/submissions/${submissionId}/comments`, {
    ...(payload.body ? { body: payload.body } : {}),
    ...(attachments.length ? { attachments } : {}),
    ...(payload.removesFileIds.length ? { removes_file_ids: payload.removesFileIds } : {}),
  });
}
